/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ECourseArea } from "../types/ECourseArea.ts";

/**
 * @description 1 = Exact | 2 = Biological | 3 = Human | 4 = VeterinaryMedicine |
 */
export const eCourseAreaSchema = z
  .union([z.literal(1), z.literal(2), z.literal(3), z.literal(4)])
  .describe(
    "1 = Exact | 2 = Biological | 3 = Human | 4 = VeterinaryMedicine | ",
  ) as unknown as ToZod<ECourseArea>;
